export interface LoginForm {
  mobile: string;
  code: string;
}

export interface Response<T = never> {
  msg: string;
  code: string;
  data: T;
}

export function isResponse(obj: any): obj is Response<any> {
  return typeof obj === 'object' && obj.msg !== undefined && obj.code !== undefined;
}
